module.exports = __webpack_public_path__ + "img/439f.ca1b553a.png";